import YYForm from './form'
import YYFormItem from './form-item'

YYForm.YYFormItem = YYFormItem
export default YYForm